<div class="modal-header d-flex align-items-center border-0">
  <i class="fa-solid fa-circle-exclamation fa-3x text-warning mr-2"></i>
  <h5 class="m-0">{{ titleKey | translate }}</h5>
  <button type="button" class="close align-self-start" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fa-solid fa-circle-xmark text-danger"></i>
  </button>
</div>

<div class="modal-body">
  <b>{{ messageKey | translate }}</b>
</div>

<div class="modal-footer border-0">
  <div class="row justify-content-center w-100">
    <div class="col-12 col-md-7 text-center">
      <button
        (click)="activeModal.close()"
        type="button"
        class="btn btn-danger rounded p-3 mb-2 shadow-sm w-100"
        translate
      >
        CLOSE
      </button>
    </div>
  </div>
</div>
